<template>
  <div v-show="showPopUps" class="popups">
    <div class="popups__content" mg-stat-mod="c_hwuppop">
      <div
          ref="main"
          :mg-stat-custom="'label=pop&cont=点击弹窗&direct=cntp&addr='+encodeURIComponent(currentPopUp.adLink)"
          :mg-stat-lob="`ad_id=${currentPopUp.adId}&goods_id=`+getRequest()"
          class="popups__main"
          mg-stat-click
      ></div>
      <div class="popups__close">
        <img
            :mg-stat-custom="'label=pop&cont=关闭&direct=cntp&addr='+encodeURIComponent(currentPopUp.adLink)"
            :mg-stat-lob="`ad_id=${currentPopUp.adId}&goods_id=`+getRequest()"
            :src="popupsButton"
            mg-stat-click
            @click="closePopUps"/>
      </div>
    </div>
  </div>
</template>
<script>
import DataStore from 'utils/dataStore';
import popupsButton from 'assets/img/popups-button.png';
import _ from 'lodash';
import MgStat from 'MgStat';

export default {
  props: ['popUpsList'],
  data() {
    return {
      popupsButton,
      showPopUps: false,
      homeAdList: [], // 已经查看的弹窗列表
      tomorrowTime: this.getTomorrowTime(), // 获取第二天的时间戳
      currentPopUp: {}, // 当前弹窗信息
    };
  },
  watch: {
    popUpsList: {
      handler(val) {
        if (val) {
          this.getGoodsDetailAd();
        }
      },
    },
  },
  methods: {
    getGoodsDetailAd() {
      if (!_.isEmpty(this.popUpsList)) {
        // 获取已经查看过的弹窗
        const cookiehomeAdList = DataStore.getStorage(
          'showHomeAdList',
          'cookie',
        );
        if (cookiehomeAdList) {
          this.homeAdList = JSON.parse(cookiehomeAdList);
        }
        // 已经看过的不需要重复
        let i = 0;
        while (i <= this.popUpsList.length - 1) {
          if (this.homeAdList.indexOf(this.popUpsList[i].adId) === -1) {
            this.showPopUps = true;
            this.currentPopUp = this.popUpsList[i];
            this.homeAdList.push(this.currentPopUp.adId);
            this.$refs.main.style.backgroundImage = `url( ${this.currentPopUp.adCode})`;
            this.$refs.main.onclick = () => {
              if (this.homeAdList) {
                // 将看过的广告保存
                DataStore.setStorage(
                  'showHomeAdList',
                  JSON.stringify(this.homeAdList),
                  'cookie',
                  this.getTomorrowTime(),
                );
              }
              window.location.href = this.currentPopUp.adLink;
              this.showPopUps = false;
            };
            MgStat.send('cv', {
              ad_id: this.currentPopUp.adId,
              goods_id: this.getRequest(),
            }, {
              mod: 'c_hwuppop',
            });
            break;
          }
          i += 1;
        }
      } else {
        this.showPopUps = false;
      }
    },
    /** 关闭弹窗  */
    closePopUps() {
      this.showPopUps = false;
      console.log(this.getTomorrowTime());
      DataStore.setStorage(
        'showHomeAdList',
        JSON.stringify(this.homeAdList),
        'cookie',
        this.getTomorrowTime(),
      );
    },
    getTomorrowTime() {
      const curDate = new Date();
      // 当前时间戳
      const curTamp = curDate.getTime();
      // 当日凌晨的时间戳,减去一毫秒是为了防止后续得到的时间不会达到00:00:00的状态
      const curWeeHours = new Date(curDate.toLocaleDateString()).getTime() - 1;
      // 当日已经过去的时间（毫秒）
      const passedTamp = curTamp - curWeeHours;
      // 当日剩余时间
      const leftTamp = (24 * 60 * 60 * 1000) - passedTamp;
      const leftTime = new Date();

      leftTime.setTime(leftTamp + curTamp);
      return leftTime.toGMTString();
    },
    getRequest() {
      const url = this.currentPopUp.ad_link; // 获取url中"?"符后的字串，包含？号本身。
      const theRequest = {};
      if (url && url.indexOf('goods/detail') !== -1 && url.indexOf('?') !== -1) {
        const str = url.substr(url.indexOf('?') + 1);
        const strs = str.split('&');
        for (let i = 0; i < strs.length; i += 1) {
          theRequest[strs[i].split('=')[0]] = decodeURIComponent(strs[i].split('=')[1]);
        }
      }
      return theRequest.id || '';
    },
  },
};
</script>
<style lang="scss" scoped>
.popups {
  z-index: 1000000;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;

  &__content {
    width: 688px;
  }

  &__main {
    height: 866px;
    background-repeat: no-repeat;
    background-size: contain;
    box-sizing: border-box;
    position: relative;
    bottom: 40px;
  }

  .center {
    justify-content: center;
    align-items: center;
  }

  &__close {
    line-height: 1;
    text-align: center;

    img {
      margin: 0 auto;
      width: 61px;
      height: 61px;
    }
  }
}
</style>

